import type { EmbarcacaoDetailSectionProps } from "../../embarcacao-detail-section";
import { usePropulsaoSection } from "./use-propulsao-section";
import { PropulsaoSectionView } from "./view-propulsao-section";

export function PropulsaoSection(props: EmbarcacaoDetailSectionProps) {
  const vm = usePropulsaoSection(props);

  return <PropulsaoSectionView {...vm} />;
}

export type * from "./types-propulsao-section";
